/**
 * Stable JSON key for comparing ticket assignee sets (order-independent).
 * @param {object|null|undefined} item
 * @returns {string}
 */
export function ticketAssigneesFingerprint(item) {
    if (!item) return '[]';
    if (Array.isArray(item.id_usuarios_atribuidos) && item.id_usuarios_atribuidos.length > 0) {
        return JSON.stringify(
            [...item.id_usuarios_atribuidos]
                .map((id) => Number(id))
                .filter((n) => Number.isFinite(n))
                .sort((a, b) => a - b)
        );
    }
    if (item.id_usuario_atribuido != null && item.id_usuario_atribuido !== '') {
        const n = Number(item.id_usuario_atribuido);
        return JSON.stringify(Number.isFinite(n) ? [n] : []);
    }
    return '[]';
}

export function itemIsAssignedToUser(item, uid) {
    const me = Number(uid);
    if (!item || !Number.isFinite(me)) return false;
    if (Array.isArray(item.id_usuarios_atribuidos) && item.id_usuarios_atribuidos.some((id) => Number(id) === me)) {
        return true;
    }
    if (item.id_usuario_atribuido == null || item.id_usuario_atribuido === '') return false;
    return Number(item.id_usuario_atribuido) === me;
}

export function assigneesArrayFromItem(item) {
    if (!item) return [];
    if (Array.isArray(item.id_usuarios_atribuidos) && item.id_usuarios_atribuidos.length > 0) {
        return [...item.id_usuarios_atribuidos].map((id) => Number(id)).filter((n) => Number.isFinite(n));
    }
    if (item.id_usuario_atribuido != null && item.id_usuario_atribuido !== '') {
        const n = Number(item.id_usuario_atribuido);
        return Number.isFinite(n) ? [n] : [];
    }
    return [];
}

/**
 * Human-readable assignee line for lists/cards/detail (all assignees when API sends usuarios_atribuidos).
 * Prefer structured names over nome_usuario_atribuido so multiple assignees are not hidden by legacy single-user label.
 * @param {object|null|undefined} item
 * @returns {string}
 */
export function ticketAssigneesDisplayLabel(item) {
    if (!item) return '';
    if (Array.isArray(item.usuarios_atribuidos) && item.usuarios_atribuidos.length) {
        const parts = item.usuarios_atribuidos.map((u) => u && u.nome_usuario).filter(Boolean);
        if (parts.length) return parts.join(', ');
    }
    if (item.nome_usuario_atribuido != null && String(item.nome_usuario_atribuido).trim() !== '') {
        return String(item.nome_usuario_atribuido).trim();
    }
    return '';
}

/**
 * @param {object} editedItem
 * @param {object|number|null} payload
 * @param {import('vue').default} vm - component instance for $set
 */
export function applyAssignUserPayloadToEditedItem(editedItem, payload, vm) {
    if (typeof payload === 'object' && payload !== null && Array.isArray(payload.id_usuarios_atribuidos)) {
        const ids = payload.id_usuarios_atribuidos.map((id) => Number(id)).filter((n) => Number.isFinite(n));
        vm.$set(editedItem, 'id_usuarios_atribuidos', ids);
        editedItem.id_usuario_atribuido =
            payload.id_usuario_atribuido != null ? payload.id_usuario_atribuido : (ids.length ? ids[0] : null);
        editedItem.nome_usuario_atribuido = payload.nome_usuario_atribuido || null;
        return;
    }
    const id = typeof payload === 'object' && payload !== null ? payload.id_usuario_atribuido : payload;
    editedItem.id_usuario_atribuido = id != null ? id : null;
    vm.$set(editedItem, 'id_usuarios_atribuidos', id != null ? [Number(id)].filter((n) => Number.isFinite(n)) : []);
    editedItem.nome_usuario_atribuido =
        typeof payload === 'object' && payload !== null && payload.nome_usuario_atribuido
            ? payload.nome_usuario_atribuido
            : null;
}
